import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { AppButton } from '@/components'
import { useAddMoneyStore } from '@/store/useAddMoneyStore'

export const AddMoneyButtonConfirmation: React.FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const fiatAmount = useAddMoneyStore((state) => state.fiatAmount)
  const cryptoAmount = useAddMoneyStore((state) => state.cryptoAmount)
  const selectedCurrency = useAddMoneyStore((state) => state.selectedCurrency)
  const isLoading = useAddMoneyStore((state) => state.isLoading)
  const shakeComponent = useAddMoneyStore((state) => state.shakeComponent)

  // Check if we can proceed
  const canSubmit =
    selectedCurrency &&
    fiatAmount.amount &&
    cryptoAmount.amount &&
    Number(fiatAmount.amount) > 0 &&
    Number(cryptoAmount.amount) > 0

  const handleAddMoney = () => {
    if (!canSubmit) {
      shakeComponent()
      return
    }

    // Navigate to the confirmation page
    navigate('/add-money/confirm')
  }

  return (
    <AppButton
      label={t('form:actions.addMoney')}
      onPress={handleAddMoney}
      isLoading={isLoading}
      disabled={!canSubmit}
      size="large"
      style={{ width: '100%' }}
    />
  )
}
